@if (buttonVisible) {
    @for (panel of _availablePanels; track panel) {
        <lg-button
            [isDisabled]="_disabled"
            [icon]="panel.icon || ''"
            [textLc]="panel.nameLc"
            data-testid="lg-slideout-button-row.button"
            [attr.data-panel-variant]="panel.panelVariant"
            (click)="_togglePanel(panel)"
            style="margin-left: 10px"
        />
    }
}
